import { LoggerService } from './utils';

import { Component, Vue, Watch } from 'vue-property-decorator';
import { LoggerTypeEnum } from './enums/LoggerTypeEnums';
import { AppSettingsStore } from './store/store.appSettings';
import { AppSettingsService, OnlineService } from './services/index';

@Component
export default class App extends Vue {
    public routeName: string = 'home';
    public registration: any = null;
    public updateExists = false;
    public refreshing = false;

    public beforeCreate() {
        LoggerService.LogDebug(`app beforeCreate`);
    }

    public created() {
        LoggerService.LogDebug(`app create`);

        // Listen for the custom event from registration
        document.addEventListener('swUpdated', this.updateAvailable, { once: true });
    }

    public beforeMount() {
        LoggerService.LogDebug(`app beforeMount`);
    }

    public async mounted() {
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'localdev') {
            LoggerService.defaultLogLevel = LoggerTypeEnum.DEBUG;
        }

        // add listener to page realod events, e.g. press F5
        const self = this;
        window.addEventListener(
            'beforeunload',
            (e) => {
                if (self.$route.name && self.$route.name !== 'dashboard') {
                    e.preventDefault();
                    e.returnValue = '';
                }
            },
            false,
        );

        // check if page was reloaded and go to dashboard if not already there
        const nav = performance.getEntriesByType('navigation');
        if (nav && nav.length > 0 && (nav[0] as PerformanceNavigationTiming).type && (nav[0] as PerformanceNavigationTiming).type === 'reload') {
            if (self.$route.name == null || (self.$route.name && self.$route.name !== 'dashboard')) {
                self.$router.push({ name: 'dashboard' });
            }
        }

        await OnlineService.FetchIsOnline().then(async (data) => {
            await AppSettingsService.FetchAppSettings();
        });
    }

    public beforeDestroy() {
        LoggerService.LogDebug(`app beforeDestroy`);
        AppSettingsStore.SetAppStoped();
    }

    @Watch('$route', { immediate: true, deep: true })
    public onRouteChanged(newValue: any) {
        LoggerService.LogDebug(`Route changed: ${newValue.name}`);
        this.routeName = newValue.name || 'dashboard';
    }

    public updateAvailable() {
        this.updateExists = true;
    }

    public refreshApp() {
        this.updateExists = false;
        if (navigator.serviceWorker) {
            let refreshing = false;
            /**
             * This listener is called when the service-worker.js has
             * triggered the `self.skipWaiting()` method
             */
            navigator.serviceWorker.addEventListener('controllerchange', (event) => {
                if (!refreshing) {
                    refreshing = true;
                    window.location.reload();
                }
            });
            /**
             * Send a message to the service-worker.js to trigger
             * the `self.skipWaiting()` method.
             * See also https://whatwebcando.today/articles/handling-service-worker-updates/
             */
            navigator.serviceWorker.getRegistration().then((response) => {
                if (response && response.waiting) {
                    response.waiting.postMessage('SKIP_WAITING');
                }
            });
        }
    }
}
